import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingBusinessProfessional.css";

export default function BusinessProfessionalLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="landing professional-landing">

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <nav className={`navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="logo-img"
          />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>

          <a
            href="#why"
            onClick={() => setMenuOpen(false)}
          >
            Why Nessefy
          </a>

          <a
            href="#how"
            onClick={() => setMenuOpen(false)}
          >
            How It Works
          </a>

          <a
            href="#community"
            onClick={() => setMenuOpen(false)}
          >
            Community
          </a>

        </div>

        <div className="nav-actions">

          <button
            className="nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>

      </nav>


      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="hero professional-hero">

        <div className="hero-blob blob-1"></div>
        <div className="hero-blob blob-2"></div>
        <div className="hero-blob blob-3"></div>

        <div className="hero-content">

          <p className="hero-badge">
            💼 BUILT FOR PEOPLE WHO WANT TO GROW
          </p>

          <h1>
            Your Next
            <br />
            Opportunity
            <br />

            <span className="highlight">
              Could Be One
              <span> Connection Away.</span>
            </span>
          </h1>

          <p>
            Connect with entrepreneurs, founders, businesses,
            investors and professionals who can help you grow,
            collaborate and discover your next opportunity.
          </p>

          <div className="hero-buttons">

            <button
              className="primary-btn"
              onClick={goToRegister}
            >
              💼 Join Nessefy
              <span className="button-arrow">
                →
              </span>
            </button>

            <button
              className="secondary-btn"
              onClick={() => scrollTo("how")}
            >
              See How It Works
            </button>

          </div>

          <div className="free-points">

            <span>
              <b>✓</b> 100% free to join
            </span>

            <span>
              <b>✓</b> No credit card
            </span>

            <span>
              <b>✓</b> Built for professionals
            </span>

          </div>

        </div>


        {/* =================================================
            HERO VISUAL
        ================================================= */}

        <div className="hero-card professional-hero-card">

          <div className="floating-mini-card mini-card-1">

            <h4>
              🚀 Career Growth
            </h4>

            <p>
              Discover your next opportunity
            </p>

          </div>


          <div className="post-card professional-post-card">

            <div className="professional-network">

              <div className="network-circle network-one">
                👨🏻‍💼
              </div>

              <div className="network-circle network-two">
                👩🏻‍💼
              </div>

              <div className="network-circle network-three">
                👨🏽‍💻
              </div>

              <div className="network-line line-one"></div>
              <div className="network-line line-two"></div>
              <div className="network-line line-three"></div>

              <div className="network-center">

                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />

              </div>

            </div>

            <div className="post-card-copy">

              <h3>
                Grow Your Network.
              </h3>

              <p>
                The right professional connection can open
                doors you never knew existed.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FREE STRIP
      ===================================================== */}

      <section className="free-strip">

        <div className="free-strip-icon">
          ✓
        </div>

        <div>

          <strong>
            Joining Nessefy is completely free.
          </strong>

          <span>
            Build your professional presence, discover
            opportunities and connect with the right people.
            No subscription. No joining fee.
          </span>

        </div>

        <button onClick={goToRegister}>
          Join Free →
        </button>

      </section>


      {/* =====================================================
          SHOWCASE
      ===================================================== */}

      <section className="showcase">

        <div className="showcase-content">

          <span className="showcase-tag">
            GROW YOUR PROFESSIONAL NETWORK
          </span>

          <h2>
            Stop networking
            <br />
            randomly.
            <br />

            <span className="showcase-highlight">
              Start connecting strategically.
            </span>
          </h2>

          <p>
            Nessefy gives business professionals one place to
            discover entrepreneurs, founders, companies,
            investors and other professionals who can create
            meaningful opportunities.
          </p>

          <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="/App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>

          <div className="showcase-benefits">

            <div>

              <span>
                01
              </span>

              <strong>
                Discover
              </strong>

              <p>
                Find people, businesses and opportunities
                relevant to your professional journey.
              </p>

            </div>


            <div>

              <span>
                02
              </span>

              <strong>
                Connect
              </strong>

              <p>
                Start meaningful conversations with people
                beyond your existing network.
              </p>

            </div>


            <div>

              <span>
                03
              </span>

              <strong>
                Grow
              </strong>

              <p>
                Turn valuable connections into collaborations,
                opportunities and long-term relationships.
              </p>

            </div>

          </div>

        </div>


        {/* PHONE */}

        <div className="phone-showcase">

          <div className="floating-ui ui-top-left">
            💼 Professional Network
          </div>

          <div className="floating-ui ui-top-right">
            🚀 New Opportunities
          </div>

          <div className="floating-ui ui-bottom-left">
            🤝 Meaningful Connections
          </div>

          <div className="floating-ui ui-bottom-right">
            ✨ Free to Join
          </div>


          <div className="phone-frame">

            <div className="phone-notch"></div>

            <div className="phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY NESSEFY
      ===================================================== */}

      <section
        id="why"
        className="features"
      >

        <div className="features-header">

          <span className="features-tag">
            WHY JOIN NESSEFY?
          </span>

          <h2>
            Your professional
            <br />
            network should work harder.
          </h2>

          <p>
            Your network isn't just a list of contacts.
            It can be the source of your next opportunity,
            collaboration, client, mentor or business idea.
          </p>

        </div>


        <div className="journey-container">

          <div className="journey-card">

            <div className="journey-step">
              01
            </div>

            <div className="journey-icon">
              🔎
            </div>

            <h3>
              Discover
            </h3>

            <p>
              Explore professionals, entrepreneurs,
              businesses and investors across different
              industries.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card featured-journey">

            <div className="journey-step">
              02
            </div>

            <div className="journey-icon">
              🤝
            </div>

            <h3>
              Connect
            </h3>

            <p>
              Build relationships with people who share
              your interests, goals and professional ambitions.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card">

            <div className="journey-step">
              03
            </div>

            <div className="journey-icon">
              📈
            </div>

            <h3>
              Grow
            </h3>

            <p>
              Turn connections into collaborations,
              opportunities and professional growth.
            </p>

          </div>

        </div>


        <div className="features-stats">

          <div>

            <h4>
              FREE
            </h4>

            <p>
              Join Nessefy
            </p>

          </div>


          <div>

            <h4>
              AI
            </h4>

            <p>
              Smarter connections
            </p>

          </div>


          <div>

            <h4>
              1
            </h4>

            <p>
              Professional ecosystem
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          HOW IT WORKS
      ===================================================== */}

      <section
        id="how"
        className="about"
      >

        <div className="about-content">

          <span className="about-tag">
            HOW IT WORKS
          </span>

          <h2>

            From
            <br />

            “I want to grow”
            <br />

            to

            <span className="how-highlight">
              “I found the right people.”
            </span>

          </h2>


          <p>
            Building a strong professional network doesn't
            have to feel complicated. Create your profile,
            showcase what you do and start discovering
            people who could be valuable to your journey.
          </p>


          <div className="about-points">

            <div>

              <h4>
                01 — Build your profile
              </h4>

              <p>
                Showcase your experience, skills, interests,
                expertise and professional goals.
              </p>

            </div>


            <div>

              <h4>
                02 — Discover opportunities
              </h4>

              <p>
                Find professionals, entrepreneurs,
                businesses and people who align with
                your interests.
              </p>

            </div>


            <div>

              <h4>
                03 — Build meaningful relationships
              </h4>

              <p>
                Start conversations, exchange ideas and
                turn the right connections into opportunities.
              </p>

            </div>

          </div>

        </div>


        {/* ORBIT VISUAL */}

        <div className="about-visual">

          <div className="orbit-card about-card-1">
            Entrepreneur
          </div>

          <div className="orbit-card about-card-2">
            Founder
          </div>

          <div className="orbit-card about-card-3">
            Investor
          </div>

          <div className="orbit-card about-card-4">
            Business
          </div>

          <div className="orbit-card about-card-5">
            Professional
          </div>


          <div className="about-center-card professional-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Grow Your Network
            </h3>

            <p>
              Skills • Experience • Opportunity
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          COMMUNITY
      ===================================================== */}

      <section
        id="community"
        className="community-section"
      >

        <div className="community-content">

          <span className="community-tag">
            ONE PROFESSIONAL ECOSYSTEM
          </span>

          <h2>
            Your next opportunity
            <br />
            may already be in your network.
          </h2>

          <p>
            Nessefy brings together entrepreneurs, founders,
            professionals, freelancers, investors and
            businesses in one ecosystem built around
            meaningful connections.
          </p>


          <div className="community-people">

            <div className="community-avatar">
              👨🏻‍💼
            </div>

            <div className="community-avatar">
              👩🏻‍💼
            </div>

            <div className="community-avatar">
              👨🏽‍💻
            </div>

            <div className="community-avatar">
              👩🏽‍🚀
            </div>

            <div className="community-avatar">
              👨🏻‍🎨
            </div>

            <div className="community-count">
              +
            </div>

          </div>


          <div className="community-labels">

            <span>
              Professionals
            </span>

            <span>
              Entrepreneurs
            </span>

            <span>
              Founders
            </span>

            <span>
              Businesses
            </span>

            <span>
              Investors
            </span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <section className="contact-section final-professional-cta">

        <div className="contact-content">

          <span className="contact-tag">
            YOUR NEXT OPPORTUNITY
          </span>

          <h2>
            Don't limit your
            <br />
            professional network
            <br />
            to where you work.
          </h2>

          <h3>
            Build your network on
            <span>
              Nessefy.
            </span>
          </h3>

          <p>
            Join for free. Create your professional profile.
            Discover people, businesses and opportunities
            that can help you move forward.
          </p>


          <button
            className="primary-btn final-cta-button"
            onClick={goToRegister}
          >
            💼 Join Nessefy
            <span>
              — It's Free
            </span>
          </button>


          <div className="final-free-line">

            ✓ Free to join

            <span>
              •
            </span>

            ✓ No credit card

            <span>
              •
            </span>

            ✓ Takes less than 2 minutes

          </div>

        </div>


        {/* FREE CARD */}

        <div className="contact-card final-free-card">

          <div className="free-card-icon">
            ✓
          </div>

          <span>
            NO CATCH.
          </span>

          <h3>

            Nessefy is
            <br />

            <strong>
              100% FREE
            </strong>

            <br />

            to join.

          </h3>

          <p>
            Build your professional profile and
            start connecting with people who
            can help you grow.
          </p>

          <button
            onClick={goToRegister}
            className="free-card-button"
          >
            Create My Free Profile →
          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ===================================================== */}

      <footer className="footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="footer-links">

          <span
            onClick={() =>
              navigate("/privacy-policy")
            }
          >
            Privacy Policy
          </span>

          <span
            onClick={() =>
              navigate("/terms-and-conditions")
            }
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}